import { render, staticRenderFns } from "./allotslist.vue?vue&type=template&id=2f0bf6fc"
import script from "./allotslist.vue?vue&type=script&lang=js"
export * from "./allotslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports